export default __webpack_public_path__ + "static/media/trr-food-smallplate-bangbang.defc96ab.png";